/* Centralised leadership, press, and org chart content for About page */

export const CHAIRMAN = {
  name: 'Gibin Philip',
  designation: 'Chairman',
  photo:
    'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/hoingqax_ChatGPT%20Image%20May%202%2C%202026%2C%2004_13_35%20PM.png',
  bio: 'Founder and Chairman of Clan Group, Gibin Philip leads a diversified industrial platform spanning infrastructure, industrial EPC, advanced welding automation, technology and consumer businesses. Headquartered in Mumbai, he has built the group across India, Africa and the Middle East with a relentless focus on engineering discipline, execution excellence and long-term value creation.',
  message: [
    'We founded Clan Group with a simple conviction — that industries are built by people who deliver. Across infrastructure, engineering, automation, technology and consumer businesses, our teams have shown what disciplined execution can achieve.',
    'In the years ahead we will continue to invest in capability, technology and talent, while expanding our footprint across emerging industrial corridors of India, Africa and the Middle East.',
    'We will remain anchored in our values — execution excellence, integrity and accountability — as we engineer progress for clients, partners, employees and the communities we serve.',
  ],
};

export const EXECUTIVE_SECRETARY = {
  name: "Chairman's Office",
  designation: 'Executive Secretary to the Chairman',
};

export const ORG_DIVISIONS = [
  {
    slug: 'clan-infra-con',
    name: 'Clan Infra-Con',
    head: 'Head — Civil Infrastructure',
    accent: '#1B3A8A',
  },
  {
    slug: 'clan-engineering',
    name: 'Clan Engineering',
    head: 'Head — Industrial EPC',
    accent: '#D4AF37',
  },
  {
    slug: 'clan-tex-installations',
    name: 'Clan Tex Installations',
    head: 'Head — Textile Engineering',
    accent: '#2A9D8F',
  },
  {
    slug: 'weldmatix-fusion',
    name: 'Weldmatix Fusion',
    head: 'Head — Welding Automation',
    accent: '#D4AF37',
    external: true,
  },
  {
    slug: 'zolvix-technologies',
    name: 'Zolvix Technologies',
    head: 'Head — Technology & SaaS',
    accent: '#1B3A8A',
    external: true,
  },
  {
    slug: 'hospitality',
    name: 'Hospitality Division',
    head: 'Head — Hospitality',
    accent: '#2A9D8F',
  },
];

export const CORPORATE_FUNCTIONS = [
  { name: 'Finance & Strategy', head: 'Group CFO' },
  { name: 'HR & Talent', head: 'Group CHRO' },
  { name: 'HSE & Quality', head: 'Head — HSE / QA-QC' },
  { name: 'Legal & Compliance', head: 'Group Legal Counsel' },
];

export const PRESS_NEWS = [
  {
    date: '2024-09-12',
    type: 'Milestone',
    title: 'Clan Group crosses 200 employees across India, Africa and the Middle East',
    summary:
      'Group headcount surpasses 200 with significant expansion across project sites in Benin, Mozambique and the UAE.',
  },
  {
    date: '2024-05-04',
    type: 'Launch',
    title: 'Zolvix Technologies launched — Solve · Build · Scale',
    summary:
      "Clan Group's technology arm Zolvix Technologies is launched, focusing on SaaS, business applications and digital transformation.",
    href: 'https://zolvix.in',
  },
  {
    date: '2023-11-20',
    type: 'Project',
    title: '54+ machines installed at Benin textile plant',
    summary:
      'Clan Tex Installations completes turnkey textile plant execution in Benin, West Africa — utility piping, boiler house and commissioning delivered.',
  },
  {
    date: '2023-03-08',
    type: 'Launch',
    title: 'Weldmatix Fusion goes global with weld overlay & cladding systems',
    summary:
      'Weldmatix Fusion expands its cladding automation portfolio — Vertical Clad Station, Continuous Rotating Torch and Pipe Cladding Rig.',
    href: 'https://weldmatixco.com',
  },
  {
    date: '2022-07-15',
    type: 'Expansion',
    title: 'International EPC mandates secured across Africa & Middle East',
    summary:
      'Clan Engineering wins multiple international turnkey EPC engagements, marking a step-change in global delivery capability.',
  },
  {
    date: '2020-01-22',
    type: 'Milestone',
    title: 'A decade of engineering progress',
    summary:
      'Clan Group marks 10 years — over 30 projects delivered across infrastructure, EPC and textile engineering.',
  },
];

export const HERO_VIDEO = {
  poster: 'https://images.pexels.com/photos/9407363/pexels-photo-9407363.jpeg',
  fallback: 'https://images.pexels.com/photos/9407363/pexels-photo-9407363.jpeg',
  sources: [
    {
      src: 'https://videos.pexels.com/video-files/3196041/3196041-uhd_2560_1440_25fps.mp4',
      type: 'video/mp4',
    },
    {
      src: 'https://videos.pexels.com/video-files/2169879/2169879-uhd_2560_1440_30fps.mp4',
      type: 'video/mp4',
    },
    {
      src: 'https://videos.pexels.com/video-files/3214448/3214448-uhd_2560_1440_25fps.mp4',
      type: 'video/mp4',
    },
  ],
};
